<div class="notifications-container">
  <mat-list *ngFor="let notification of notifications" class="notifications-item">
    <div
      *ngIf="notificationService.checkTime(notification.notificationDate)"
      (click)="visitNotification($event, notification)"
      class="person-result"
      id="notification-card"
    >
      <div class="avatar-container">
        <img *ngIf="notification.photo" [src]="notification.photo" class="result-photo" />
        <span *ngIf="!notification.photo" class="result-initials">
          {{ notification.relatedEmployee.name | initials }}
        </span>
      </div>
      <div class="bio-container">
        <span class="notification-name">{{ notification.relatedEmployee.name }}</span>
        <span class="notification-message">{{ formatMessage(notification) }}</span>
        <span class="notification-time">{{ timeSince(notification.notificationDate) }}</span>
      </div>
      <button
        id="read-button"
        matTooltip="{{ getToolTipMessage(notification.isUnread) }}"
        [matTooltipPosition]="position.value!"
        [ngClass]="notification.isUnread ? 'false-color' : 'true-color'"
        (click)="updateNotification($event, notification, notification.isUnread)"
      ></button>
    </div>
    <hr *ngIf="notificationService?.checkTime(notification.notificationDate)" class="break-line" />
  </mat-list>
</div>
